import type { QuizBuilderQuestionSchema } from '@repo/schemas/quiz/quizBuilderQuestion';

import { QuestionType } from '@repo/types/enums/questionType';

import type { QuestionFormProps } from '@/components/features/quiz/question/question-builder';

import {
  QuestionFillForm,
  QuestionLongForm,
  QuestionMatchingForm,
  QuestionMultipleForm,
  QuestionSingleForm,
  QuestionTranslateForm,
  QuestionVoiceForm,
} from '@/components/features/quiz/question/question-builder';

interface QuizBuilderQuestionTypeProps extends QuestionFormProps {
  data: QuizBuilderQuestionSchema;
}

export default function QuizBuilderQuestionType(quizBuilderQuestionTypeProps: QuizBuilderQuestionTypeProps) {
  const { data, ...props } = quizBuilderQuestionTypeProps;
  switch (data.type) {
    case QuestionType.SINGLE:
      return <QuestionSingleForm data={data} {...props} />;
    case QuestionType.MULTIPLE:
      return <QuestionMultipleForm data={data} {...props} />;
    case QuestionType.FILL:
      return <QuestionFillForm data={data} {...props} />;
    case QuestionType.TRANSLATE:
      return <QuestionTranslateForm data={data} {...props} />;
    case QuestionType.MATCHING:
      return <QuestionMatchingForm data={data} {...props} />;
    case QuestionType.LONG:
      return <QuestionLongForm data={data} {...props} />;
    case QuestionType.VOICE:
      return <QuestionVoiceForm data={data} {...props} />;
    default:
      return null;
  }
}
